import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsBookingSuccess } from '../../selectors/newbuildingBooking';
import { BookingConfirmModalContainer } from './BookingConfirmModalContainer';
import { BookingSuccessModalContainer } from './BookingSuccessModalContainer';

export const NewbuildingBookingModalContainer = () => {
  const isBookingSuccess = useSelector(selectIsBookingSuccess);

  if (isBookingSuccess) {
    return <BookingSuccessModalContainer />;
  }

  return <BookingConfirmModalContainer />;
};
